import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import { Checkbox } from 'react-bootstrap';

export default class ListItem extends React.Component {

    constructor(props) {
        super(props);
        this.onDoubleClick = this.onDoubleClick.bind(this);
    }

    onDoubleClick(e) {
        if (this.props.onDoubleClick) {
            this.props.onDoubleClick(e);
        }
    }

    render() {
        const itemRef = (item) => {
            if (item) {
                const domNode = ReactDOM.findDOMNode(item);
                domNode.ondblclick = this.onDoubleClick;
            }
        };

        let classname = `${this.props.className} list-item`;
        if (this.props.selected === true) {
            classname += ' selected';
        }

        let item = this.props.children;
        if (this.props.checkboxed && this.props.checkboxed === true) {
            item = (
                <Checkbox inline onChange={this.props.onClick}>
                    {this.props.children}
                </Checkbox>
            );
        }

        return (
            <div className={classname}
                onMouseDown={this.props.onClick}
                data-name={this.props.name}
                ref={itemRef}
                style={this.props.style}
            >
            {item}
            </div>
        );
    }

}

ListItem.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string,
    onClick: PropTypes.func,
    selected: PropTypes.bool,
    onDoubleClick: PropTypes.func,
    children: PropTypes.any,
    style: PropTypes.object,
    checkboxed: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/core/ListItem.js